export default {
  count_not_verify_sanad(state) {
    return state.count_not_verify_sanad
  },
}
